import { FormTheme, FormWidth } from '../types';

export const FORM_WIDTH_PRESETS: Record<Exclude<FormWidth, 'full' | 'custom'>, number> = {
  narrow: 560,
  medium: 720,
  wide: 960,
};

export const DEFAULT_FORM_WIDTH: FormWidth = 'medium';
export const MIN_CUSTOM_FORM_WIDTH = 320;
export const MAX_CUSTOM_FORM_WIDTH = 1600;

export const FORM_WIDTH_OPTIONS: FormWidth[] = ['narrow', 'medium', 'wide', 'full', 'custom'];

export const FORM_WIDTH_LABELS: Record<FormWidth, string> = {
  narrow: `Narrow (${FORM_WIDTH_PRESETS.narrow}px)`,
  medium: `Medium (${FORM_WIDTH_PRESETS.medium}px)`,
  wide: `Wide (${FORM_WIDTH_PRESETS.wide}px)`,
  full: 'Full width (100%)',
  custom: 'Custom',
};

export const resolveFormMaxWidth = (theme: FormTheme | null | undefined): string => {
  const width = theme?.formWidth || DEFAULT_FORM_WIDTH;
  if (width === 'full') return '100%';
  if (width === 'custom') {
    return `${theme?.formMaxWidth ?? FORM_WIDTH_PRESETS.medium}px`;
  }
  return `${FORM_WIDTH_PRESETS[width]}px`;
};

export const formWidthSx = (theme: FormTheme | null | undefined) => ({
  width: '100%',
  maxWidth: resolveFormMaxWidth(theme),
  mx: 'auto',
});
